import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { 
  UserRoundPen, 
  Landmark, 
  LoaderCircle,
  XCircle,
  CheckCircle 
} from 'lucide-react';
import { motion } from 'framer-motion';

function ItemLists({ type }) {
    const [usercount, setUserCount] = useState(0);
    const [productcount, setProductCount] = useState(0);
    const [pendingProofsCount, setPendingProofsCount] = useState(0);
    const [rejectedProofsCount, setRejectedProofsCount] = useState(0);
    const [verifiedProofsCount, setVerifiedProofsCount] = useState(0);

    useEffect(() => {
        // Fetch user count
        const fetchUserCount = async () => {
            try {
                const response = await axios.get(
                    "https://portal-sanieldanproperties-api.onrender.com/admin/user/count"
                );
                setUserCount(response.data.count);
            } catch (error) {
                console.error('Error fetching user count:', error);
                setUserCount(0); // Fallback value
            }
        };
        fetchUserCount();
    }, []);

    useEffect(() => {
        // Fetch product count
        const fetchProductCount = async () => {
            try {
                const response = await axios.get(
                    "https://portal-sanieldanproperties-api.onrender.com/admin/product/count"
                );
                setProductCount(response.data.count);
            } catch (error) {
                console.error('Error fetching product count:', error);
                setProductCount(0); // Fallback value
            }
        };
        fetchProductCount();
    }, []);

    useEffect(() => {
        // Fetch pending proofs count
        const fetchPendingProofsCount = async () => {
            try {
                const response = await axios.get(
                    // "http://localhost:3005/admin/pending-proofs"
                    'https://portal-sanieldanproperties-api.onrender.com/admin/pending-proofs'
                );
                setPendingProofsCount(response.data.length);
            } catch (error) {
                console.error('Error fetching pending proofs count:', error);
                
            }
        };
        fetchPendingProofsCount();
    }, []);

    useEffect(() => {
        // Fetch rejected proofs count
        const fetchRejectedProofsCount = async () => {
            try {
                const response = await axios.get(
                    // "http://localhost:3005/admin/rejected-proofs"
                    'https://portal-sanieldanproperties-api.onrender.com/admin/rejected-proofs'
                );
                setRejectedProofsCount(response.data.length);
            } catch (error) {
                console.error('Error fetching rejected proofs count:', error);
                
            }
        };
        fetchRejectedProofsCount();
    }, []);

    useEffect(() => {
        // Fetch verified proofs count
        const fetchVerifiedProofsCount = async () => {
            try {
                const response = await axios.get(
                    // "http://localhost:3005/admin/verified-proofs"
                    'https://portal-sanieldanproperties-api.onrender.com/admin/verified-proofs'
                );
                setVerifiedProofsCount(response.data.length);
            } catch (error) {
                console.error('Error fetching verified proofs count:', error);
                
            }
        };
        fetchVerifiedProofsCount();
    }, []);

    const getDataForType = () => {
        const typeConfigs = {
            'user': {
                title: 'USERS',
                count: usercount,
                icon: <UserRoundPen className="w-8 h-8 text-pink-500" />,
                description: 'Total registered users in the system',
                link: 'See all users',
                linkto: '/admin/dashboard/users',
                bgColor: 'bg-pink-50'
            },
            
            'products': {
                title: 'PRODUCTS',
                count: productcount,
                icon: <Landmark className="w-8 h-8 text-green-500" />,
                description: 'Total properties available',
                link: 'See all products',
                linkto: '/admin/dashboard/products',
                bgColor: 'bg-green-50'
            },
            'pending': {
                title: 'PENDING PROOFS',
                count: pendingProofsCount,
                icon: <LoaderCircle className="w-8 h-8 text-orange-500" />,
                description: 'Proof of payments awaiting verification',
                link: 'Review pending proofs',
                linkto: '/admin/dashboard/pending-proofs',
                bgColor: 'bg-orange-50'
            },
            'rejected': {
                title: 'REJECTED PROOFS',
                count: rejectedProofsCount,
                icon: <XCircle className="w-8 h-8 text-red-500" />,
                description: 'Proof of payments that were rejected',
                link: 'Review rejected proofs',
                linkto: '/admin/dashboard/rejected-proofs',
                bgColor: 'bg-red-50'
            },
            'verified': {
                title: 'VERIFIED PAYMENTS',
                count: verifiedProofsCount,
                icon: <CheckCircle className="w-8 h-8 text-green-600" />,
                description: 'Proof of payments verified',
                link: 'View verified proofs',
                linkto: '/admin/dashboard/verified-proofs',
                bgColor: 'bg-green-50'
            }
        };

        return typeConfigs[type] || {};
    };

    const data = getDataForType();

    return (
        <motion.div 
            className={`p-4 rounded-lg shadow-md ${data.bgColor} hover:shadow-xl transition-all duration-300b`}
            whileHover={{ scale: 1.05 }}
        >
            <div className="flex justify-between items-center">
                <div>
                    <h3 className="text-sm font-semibold text-gray-600 uppercase">{data.title}</h3>
                    <div className="flex items-center mt-2">
                        {data.icon}
                        <span className="ml-2 text-2xl font-bold text-gray-800">{data.count}</span>
                    </div>
                </div>
            </div>
            
            <div className="mt-4 text-sm text-gray-500">
                {data.description}
            </div>
            
            <Link 
                to={data.linkto} 
                className="mt-4 block text-blue-600 hover:underline"
            >
                {data.link}
            </Link>
        </motion.div>
    );
}

export default ItemLists;